import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TruncatedTextComponent } from 'src/app/shared-components/truncated-text/truncated-text.component';
import { PipesCommonModule } from 'src/app/pipes/pipes-common/pipes-common.module';
import { ExpandableComponent } from '../shared-components/expandable/expandable.component';
import { HeaderComponent } from '../shared-components/header/header.component';
import { ImagesComponent } from '../shared-components/images/images.component';
import { HttpErrorComponent } from '../shared-components/http-error/http-error.component';
import { SkeletonsComponent } from '../shared-components/skeletons/skeletons.component';
import { CustomAlertComponent } from '../shared-components/custom-alert/custom-alert.component';
import { StepperComponent } from '../shared-components/stepper/stepper.component';
import { PendingOrdersModalComponent } from '../pages/pending-orders/pending-orders-modal/pending-orders-modal.component';
import { PendingComponent } from '../pages/pending-orders/pending/pending.component';
import { OrderDetailsPopoverComponent } from '../pages/pending-orders/order-details-popover/order-details-popover.component';
import { ImageViewerModalComponent } from '../shared-components/image-viewer-modal/image-viewer-modal.component';
import { HttpErrorServiceComponent } from '../shared-components/http-error-service/http-error-service.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    TruncatedTextComponent,
    ExpandableComponent,
    HeaderComponent,
    ImagesComponent,
    HttpErrorComponent,
    SkeletonsComponent,
    CustomAlertComponent,
    StepperComponent,
    PendingOrdersModalComponent,
    PendingComponent,
    OrderDetailsPopoverComponent,
    ImageViewerModalComponent,
    HttpErrorServiceComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    PipesCommonModule,
    TranslateModule
  ],
  exports: [TruncatedTextComponent,
    ExpandableComponent,
    HeaderComponent,
    ImagesComponent,
    HttpErrorComponent,
    SkeletonsComponent,
    CustomAlertComponent,
    StepperComponent,
    PendingOrdersModalComponent,
    PendingComponent,
    OrderDetailsPopoverComponent,
    ImageViewerModalComponent,
    HttpErrorServiceComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  providers: []
})
export class SharedModule { }
